import styled from "styled-components";

export const StyledBar = styled.div`
  width: 100%;
  height: 1.6rem;
  text-align: center;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.header.fontColor};
  display: flex;
  justify-content: end;
`;

export const StyledButton = styled.div`
  border: none;
  height: 1.6rem;
  line-height: 1.6rem;
  background-color: transparent;
  cursor: pointer;
  font-size: 1.5rem;
  color: ${(props) => props.theme.switcher.fontColor} !important;
  font-family: "Cormorant Garamond", sans-serif;

  &:hover {
    color: ${(props) => props.theme.switcher.hoverColor} !important;
  }
`;
